import "./filter-field.css";
import { CrossX } from "../svg";
import classnames from "classnames";
import { createElement, useState } from "react";
import { IconButton } from "@mui/material";

export interface ValueData {
    key: string | number;
    object: any;
    displayValue: string;
}

export interface FilterFieldProps {
    inputValue: string;
    placeholder?: string;
    onValueChange(value: string): void;
    icon?: string | React.FunctionComponent<any> | React.ComponentClass<any>;
    isDisabled?: boolean;
}

export function SearchField(props: FilterFieldProps) {
    const { inputValue, onValueChange, placeholder, icon, isDisabled } = props;

    const [selectedIndex, setSelectedIndex] = useState(-1);

    const handleClear = () => {
        if (!isDisabled) {
            onValueChange("");
            setSelectedIndex(-1);
        }
    };

    return (
        <div
            className={classnames("filter-input-body", {
                disabled: isDisabled,
            })}
        >
            <div
                className={classnames("interaction-container", {
                    disabled: isDisabled,
                })}
            >
                <div
                    className={classnames("icon", {
                        disabled: isDisabled,
                        active: inputValue !== "",
                    })}
                >
                    {icon && createElement(icon)}
                </div>
                <input
                    placeholder={placeholder}
                    className={classnames("value-input", {
                        disabled: isDisabled,
                    })}
                    value={inputValue}
                    onChange={(event) => {
                        onValueChange(event.target.value);
                    }}
                    disabled={isDisabled}
                ></input>
                {inputValue && (
                    <div
                        className={classnames("close-button", {
                            disabled: isDisabled,
                        })}
                    >
                        <IconButton disabled={isDisabled} onClick={handleClear}>
                            <CrossX />
                        </IconButton>
                    </div>
                )}
            </div>
        </div>
    );
}
